import get from 'lodash/get';

const buildUrl = (baseUrl: any, params: any = {}) => {
  const queryString = Object.entries(params)
    .filter(([, value]: any) => value)
    .map(([name, value]: any) => `${encodeURIComponent(name)}=${encodeURIComponent(value)}`)
    .join('&');

  return `${baseUrl}/shop/${queryString && `?${queryString}`}`;
};

const buildArtistShopUrl = (baseUrl?: any, artistName?: any) => {
  return `${baseUrl}/people/${artistName}/shop?ref=typeahead`;
};

const doSearch = (searchTerm?: any, productContext?: any, baseUrl?: any, override?: any) => {
  if (typeof override === 'function') {
    override(searchTerm, productContext);
  } else {
    (window as any).location = buildUrl(baseUrl, {
      query: searchTerm,
      iaCode: get(productContext, 'id', null),
      ref: 'search_box',
    });
  }
};

export {
  doSearch,
  buildUrl,
  buildArtistShopUrl,
};
